import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.257 6.467A1.002 1.002 0 0 1 5.07 5.129l-1.23-1.39.385-.385L5.61 4.579a1 1 0 0 1 1.352 1.197l.64.568-.771.771-.574-.648Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.532a4.5 4.5 0 1 0-4 0V10H3v1h6v-1H8v-.468ZM9.5 5.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
    />
  </svg>
);
export default IconPressureStrokedSizeXs;
